import { render, staticRenderFns } from "./ImpactNumbers.vue?vue&type=template&id=75a952d3&scoped=true"
import script from "./ImpactNumbers.vue?vue&type=script&lang=js"
export * from "./ImpactNumbers.vue?vue&type=script&lang=js"
import style0 from "./ImpactNumbers.vue?vue&type=style&index=0&id=75a952d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a952d3",
  null
  
)

export default component.exports